import { Box, Button, styled, Typography } from "@mui/material";

export const UseRewardWrapper = styled(Box)({
  width: "100%",
  "& .body": {
    position: "absolute",
    width: "100%",
    paddingBottom: 20,
    "& .footerBox": {
      margin: "0 calc((100% - 333px) / 2)",
      display: "flex",
      flexDirection: "column",
      alignItems: "center",
      marginTop: 15,
      ".notice_text": {
        fontWeight: 500
      },
      "& .notice": {
        color: "#DA314F"
      }
    },
  }
});

export const QRCodeWrapper = styled(Box)({
  width: 333,
  height: "100%",
  borderRadius: "10px",
  background: "#fff",
  margin: "0 calc((100% - 333px) / 2)",
  display: "flex",
  alignItems: "center",
  flexDirection: "column",
  border: "1px solid #EBEBEB",
  boxShadow: "0px 19px 38px rgba(58, 76, 130, 0.1)",
  padding: 20,
});

export const ReportButtonWrapper = styled(Box)({
  marginTop: 20,
  width: 330,
  height: "100%",
});

export const RedeemCode = styled(Typography)({
  fontSize: 18,
  lineHeight: "21px",
  letterSpacing: "2px",
  color: "#000000"
});

export const ScanToRedeemButton = styled(Button)({
  width: "100%",
  fontSize: 14,
  lineHeight: "17px",
  fontWeight: 300,
  height: 48,
  position: "sticky",
  bottom: 20,
  "& .MuiButton-startIcon": {
    marginRight: 0
  },
  "svg": {
    marginTop: 3,
    width: 41,
    height: 41
  }
});

export const LinkToast = styled(Box)({
  position: "absolute",
  top: "60%",
  left: "50%",
  transform: "translate(-50%, -50%)",
  backgroundColor: "rgba(0,0,0,0.6)",
  color: "#fff",
  padding: "1px 10px",
  borderRadius: 5,
  boxShadow: "0 2px 5px rgba(0, 0, 0, 0.3)",
  zIndex: 1000,
  fontSize: 14,
  animation: "fadein 0.5s ease, fadeout 0.5s ease 1.5s",
  animationFillMode: "forwards",
  "@keyframes fadein": {
    from: { opacity: 0 },
    to: { opacity: 1 }
  },
  "@keyframes fadeout": {
    from: { opacity: 1 },
    to: { opacity: 0, visibility: "hidden" }
  }
});

export const NotificationWrapper = styled(Box)(`
  margin: 0 calc((100% - 333px) / 2);
  background-color: #FDEFE8;
  border: 1px dashed rgba(239, 91, 27, 0.5);
  border-radius: 10px;
  margin-bottom: 20px;
  padding: 15px;
  display: flex;
  align-items: center;
  & .detail {
    color: #333333;
    font-size: 12px;
  };
  & .viewOtherBtn {
    font-size: 12px;
    font-weight: 400;
    padding: 0;
    line-height: 18px;
  }
`);
